export const STEP = 15;
export const TIMES_SLOTS = 4;
export const CURRENT_DATE_CALENDAR_KEY = 'currentDateCalendar';
export const CURRENT_VIEW_CALENDAR_KEY = 'currentViewCalendar';
export const CLASSNAME_ALL_DAY = 'drag-from-allday';

export const GET_EVENTS_DELAY = 500;

export const REDIRECT_URI = `${window.location.origin}${window.location.pathname}`;
